<template>
  <v-container fluid class="financereport-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="3" class="d-flex flex-start justify-md-start">
              <v-btn 
                color="success" 
                class="button-shadow mr-2"
                @click="findFinanceReportDialog = true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" to="/financereport/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
              <v-btn 
                color="primary" 
                class="button-shadow mr-2"
                @click="printItem"
                v-show="data_reports.length>0"
              >
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="csv"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_reports.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="financereports-table"
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="header_order"
              :items="data_reports"
              :items-per-page="itemPerPage">
              <template v-slot:item.orderdate="{ item }">
                {{ item.orderdate!=null ? new Date(item.orderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
              </template>
              <template v-slot:item.orderduedate="{ item }">
                {{ item.orderduedate!=null ? new Date(item.orderduedate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
              </template>
              <template v-slot:item.orderimage="{ item }">
                  <img v-bind:src="item.orderimage" alt="" width="60">
              </template>
              <template v-slot:item.ordertotal="{ item }">
                {{ item.ordertotal!==undefined ? (item.ordertotal).toFixed(1) : '' }}
              </template>
              <template v-slot:item.received_amount="{ item }">
                {{ item.received_amount!==undefined ? (item.received_amount).toFixed(1) : '' }}
              </template>
              <template v-slot:item.balance="{ item }">
                {{ item.balance!==undefined ? (item.balance).toFixed(1) : '' }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="findFinanceReportDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Finance Report</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-menu
                  ref="menu_enddate"
                  v-model="menu_enddate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.enddate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.enddate"
                      label="End Date"
                      v-bind="attrs"
                      v-bind:value="find_query.enddate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter end date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.enddate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_enddate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_enddate.save(find_query.enddate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="find_query = {}"
          >
            Clear
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findFinanceReportDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findFinanceReport"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'FinanceReportByItem',
  data() {
    return {
      header_order: [
        { text: 'Date', value: 'orderdate', width: '12%', format: 'date' },
        { text: 'Due Date', value: 'orderduedate', width: '12%', format: 'date' },
        { text: 'Order-Invoice', value: 'ordernum', width: '12%' },
        { text: 'Customer Name', value: 'ordername' },
        { text: 'Amount', value: 'ordertotal', width: '10%', align: 'right', format: 'decimal'},
        { text: 'Received', value: 'received_amount', width: '10%', align: 'right', format: 'decimal' },
        { text: 'Balance', value: 'balance', width: '10%', align: 'right', format: 'decimal' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      findFinanceReportDialog: false,
      find_query: {},
      data_reports: [],
      finance_invoices: [],
      menu_startdate: null,
      menu_enddate: null,
      offset: 0,
      report_name: 'Accounts Receivables Report',
      report_date: new Date(),
    }
  },
  computed: {
    ...mapState('FinanceReport', ['report', 'financereports','isDeleting', 'isReceiving']),
    ...mapState('Location', ['locations']),
    ...mapState('Region', ['regions']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
    data_channels(){
      return this.saleschannels.filter(x=>x.channelstatus=='Active' || x.channelstatus=='New').map(x => {return {text: x.channelname, value: x._id};});
    },
    data_locations(){
      return this.locations.filter(x=>x.locationstatus=='Active' || x.locationstatus=='New').map(x => {return {text: x.locationname, value: x._id};});
    },
    data_users(){
      return this.users.filter(x=>x.userstatus=='Active' && x.locationid==this.find_query.locationid).map(x => {return {text: x.username, value: x._id};});
    }
  },
  methods: {
    ...mapActions('FinanceReport', ["setReport", "findFinanceReportReceivablesRequest", "getFinanceReportReceivablesRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('SalesChannel', ["getSalesChannelsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    printItem() {
      let report = {companyid: this.companyid, report_date: this.report_date, report_name: this.report_name}
      this.$router.push({ name: 'PrintReport', params: {report: report, data: this.data_reports, header: this.header_order} });
    },
    calculateTotal(){
      this.report_date = this.data_reports.length>0 ? new Date(this.data_reports[0]['report_date']) : new Date();
      this.data_reports.push({
        ordertotal: this.data_reports.reduce(function (last, json) {return last + json.ordertotal;}, 0),
        received_amount: this.data_reports.reduce(function (last, json) {return last + json.received_amount;}, 0), 
        balance: this.data_reports.reduce(function (last, json) {return last + json.balance;}, 0), 
        isSum: true
      });
    },
    async findFinanceReport(){
      this.findFinanceReportDialog = false;
      this.data_reports = [];
      if(Object.keys(this.find_query).length==0){
        let result = await this.getFinanceReportReceivablesRequest();
        this.data_reports = result;
        this.calculateTotal();
      }
      else{
        let result = await this.findFinanceReportReceivablesRequest(this.find_query);
        this.data_reports = result;
        this.calculateTotal();
      }
    },
    getJson(){
      let json = this.data_reports.map(report=>{return {
        orderdate: report.orderdate!=null ? new Date(report.orderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        orderduedate: report.orderduedate!=null ? new Date(report.orderduedate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        ordernum: report.ordernum,
        ordername: report.ordername,
        orderamount: report.ordertotal ? report.ordertotal.toFixed(2) : 0,
        received: report.received_amount ? report.received_amount.toFixed(2) : 0, 
        balance: report.balance ? report.balance.toFixed(2) : 0,
      }});
      return json;
    },
    getFileName(){
      var d = this.report_date;
      var name = 'finance-receivables-report-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.csv';
    },
  },
  async created () {
    if(this.report!=this.report_name || (this.financereports==null || this.financereports.length==0)) await this.getFinanceReportReceivablesRequest();
    this.data_reports = Object.assign([], this.financereports);
    this.calculateTotal();

    this.companyid = localStorage.getItem('companyid');
    this.setReport(this.report_name);

    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
